import { z } from "zod";
import { RoleSchema } from "../../shared/schemas/role.schema.js";

export const OrgMembershipSchema = z
  .object({
    orgId: z.string().min(1),
    orgName: z.string().min(1),
  })
  .strict();

export type OrgMembership = z.infer<typeof OrgMembershipSchema>;

export const UserResponseSchema = z
  .object({
    id: z.string().min(1),
    email: z.email(),
    name: z.string(),
    roles: z.array(RoleSchema),
    orgMemberships: z.array(OrgMembershipSchema),
    createdAt: z.iso.datetime(),
    lastLogin: z.iso.datetime().nullable(),
  })
  .strict();

export type UserResponse = z.infer<typeof UserResponseSchema>;

export const UserSortSchema = z.enum([
  "email:asc",
  "email:desc",
  "last_login:asc",
  "last_login:desc",
]);
export type UserSort = z.infer<typeof UserSortSchema>;

export const ListUsersQuerySchema = z
  .object({
    search: z.string().trim().min(1).max(200).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    page: z.coerce.number().int().min(1).default(1),
    sort: UserSortSchema.default("email:asc"),
  })
  .strict();

export type ListUsersQuery = z.infer<typeof ListUsersQuerySchema>;

export const ListUsersResponseSchema = z
  .object({
    items: z.array(UserResponseSchema),
    total: z.number().int().nonnegative(),
  })
  .strict();

export type ListUsersResponse = z.infer<typeof ListUsersResponseSchema>;
